import React from 'react';
import copyIcon from '../../icons/non-prefilled/16x16/copy.svg';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import { UIActions } from '../../ui/uiSlice';
import { MenuItem } from '../../components/Menu';
import { useToolbarOverflowMenuClose } from './toolbar/Toolbar';

interface CopyLinkMenuItemProps {
  link: string;
}

const CopyLinkMenuItem = ({ link }: CopyLinkMenuItemProps) => {
  const closeOverflowMenu = useToolbarOverflowMenuClose();
  const dispatch = useAppDispatch();

  return (
    <MenuItem
      icon={copyIcon}
      onClick={async () => {
        await navigator.clipboard.writeText(link);
        dispatch(
          UIActions.pushToast({
            level: 'success',
            message: 'Link copied',
          }),
        );
        closeOverflowMenu();
      }}
      testId="copyLinkMenuItem"
    >
      Copy link
    </MenuItem>
  );
};

export default CopyLinkMenuItem;
